import { useEffect, useRef, useState } from 'react';

interface AmbientSoundProps {
    isMuted: boolean;
}

const AmbientSound = ({ isMuted }: AmbientSoundProps) => {
    const fireRef = useRef<HTMLAudioElement>(null);
    const tropicalRef = useRef<HTMLAudioElement>(null);
    const streamRef = useRef<HTMLAudioElement>(null);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        // Attendre l'interaction utilisateur avant de jouer (politique des navigateurs)
        const playAudios = async () => {
            try {
                if (!isMuted && isReady) {
                    // Les promesses de lecture peuvent être rejetées si le chargement échoue ou est bloqué
                    const playPromises = [
                        fireRef.current?.play(),
                        tropicalRef.current?.play(),
                        streamRef.current?.play()
                    ];
                    await Promise.allSettled(playPromises);
                } else {
                    fireRef.current?.pause();
                    tropicalRef.current?.pause();
                    streamRef.current?.pause();
                }
            } catch (error) {
                console.log('Audio autoplay prevented:', error);
            }
        };

        playAudios();
    }, [isMuted, isReady]);

    useEffect(() => {
        // Définir les volumes
        if (fireRef.current) fireRef.current.volume = 0.02; // 2%
        if (tropicalRef.current) tropicalRef.current.volume = 0.9; // 90%
        if (streamRef.current) streamRef.current.volume = 0.04; // 4%

        // Marquer comme prêt après un court délai
        const timer = setTimeout(() => setIsReady(true), 1000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            {/* Crépitement du feu */}
            <audio
                ref={fireRef}
                loop
                preload="none"
            >
                <source src="/sounds/fire-crackle.mp3" type="audio/mpeg" />
                <source src="/sounds/fire-crackle.ogg" type="audio/ogg" />
            </audio>

            {/* Ambiance nuit tropicale */}
            <audio
                ref={tropicalRef}
                loop
                preload="none"
            >
                <source src="/sounds/tropical-night.mp3" type="audio/mpeg" />
                <source src="/sounds/tropical-night.ogg" type="audio/ogg" />
            </audio>

            {/* Ruisseau */}
            <audio
                ref={streamRef}
                loop
                preload="none"
            >
                <source src="/sounds/stream.mp3" type="audio/mpeg" />
                <source src="/sounds/stream.ogg" type="audio/ogg" />
            </audio>
        </>
    );
};

export default AmbientSound;
